/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { select } from '@wordpress/data';
import {
	__experimentalPanelColorGradientSettings as PanelColorGradientSettings,
} from '@wordpress/block-editor';
import { has, isEmpty } from 'lodash';
import { Flex, FlexItem, Button, ColorPalette, BaseControl } from '@wordpress/components';

import { ColorControl, GradientColorControl } from './fields';

export { ColorControl, GradientColorControl };

class ColorOptions extends Component {
	constructor( props ) {
		super( props );
		this.updateStyles = this.updateStyles.bind( this );
	}

	updateStyles( styles ) {
		const { blockAdvanceOptions } = this.props.attributes;

		const _styles = {
			...blockAdvanceOptions,
			...styles,
		};

		this.props.setAttributes( { blockAdvanceOptions: { ..._styles } } );
	}
	colorFields() {
		const { attributes } = this.props;
		const { blockAdvanceOptions } = attributes;
		const fields = [];
		const backgroundColor = has( blockAdvanceOptions, 'backgroundColor' ) && ! isEmpty( blockAdvanceOptions.backgroundColor ) ? blockAdvanceOptions.backgroundColor : undefined;
		const backgroundGradient = has( blockAdvanceOptions, 'backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.backgroundGradient ) ? blockAdvanceOptions.backgroundGradient : undefined;
		fields.push( {
			label: __( 'Background Color' ),
			colorValue: backgroundColor,
			gradientValue: backgroundGradient,
			onGradientChange: ( val ) => {
				if ( isEmpty( val ) ) {
					return;
				}
				const styles = {
					backgroundGradient: val,
					backgroundColor: undefined,
				};
				this.updateStyles( styles );
				this.props.onChange( { blockAdvanceOptions: {
					...blockAdvanceOptions,
					backgroundGradient: val,
					backgroundColor: undefined,
				} } );
			},
			onColorChange: ( val ) => {
				if ( isEmpty( val ) ) {
					return;
				}
				const styles = {
					backgroundColor: val,
					backgroundGradient: undefined,
				};
				this.updateStyles( styles );
				this.props.onChange( { blockAdvanceOptions: {
					...blockAdvanceOptions,
					backgroundColor: val,
					backgroundGradient: undefined,
				} } );
			},
			disableCustomGradients: false,
			disableCustomColors: false,
			clearable: false,
		} );
		return fields;
	}
	render() {
		const { clientId, enableTextColor, attributes, onChange, setAttributes } = this.props;
		const { blockAdvanceOptions } = attributes;
		const _enableTextColor = 'undefined' === typeof enableTextColor ? true : enableTextColor;
		const colors = select( 'core/block-editor' ).getSettings().colors || [];
		return <PanelColorGradientSettings
			title={
				__( 'Color options' )
			}
			initialOpen={
				false
			}
			settings={ this.colorFields() }
			enableContrastChecking={ true }
			clientId={ clientId } >
			<BaseControl>
				<Flex>
					<FlexItem>

					</FlexItem>
					<FlexItem>
						<Button isSecondary isSmall onClick={ () => {
							this.updateStyles( {
								backgroundColor: undefined,
								backgroundGradient: undefined,
							} );
							onChange( { blockAdvanceOptions: {
								...blockAdvanceOptions,
								backgroundColor: undefined,
								backgroundGradient: undefined,
							} } );
						} }>{ __( 'Clear Background' ) }</Button>
					</FlexItem>
				</Flex>
			</BaseControl>
			{ _enableTextColor && <BaseControl label={ __( 'Text Color' ) } id="textcolor-1">
				<ColorPalette
					colors={ colors }
					value={ blockAdvanceOptions.textColor }
					onChange={ ( color ) => {
						// console.log( { blockAdvanceOptions: {
						// 	...blockAdvanceOptions,
						// 	textColor: color,
						// } } );
						setAttributes( { blockAdvanceOptions: {
							...blockAdvanceOptions,
							textColor: color,
						} } );
						onChange( { blockAdvanceOptions: {
							...blockAdvanceOptions,
							textColor: color,
						} } );
					} }
				/></BaseControl> }
		</PanelColorGradientSettings>;
	}
}
export default ColorOptions;
